module.exports = ".icon-menu{margin-right:10px}\n"